import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Auth from '../hoc/auth.js';
// pages for this product
import LoginPage from './views/User/LoginPage.js';
import ProfilePage from './views/User/ProfilePage.js';
import ChangePWPage from './views/User/ChangePWPage.js';
import ManageMemberPage from './views/Membership/ManageMemberPage.js';
import RegisterPage from './views/Membership/RegisterPage.js';
import Header from './views/Header/Header.js';
import SignupPage from './views/User/SignupPage.js';
import OrganizationPage from './views/Organization/OrganizationPage.js';
import ProjectPage from './views/Project/ProjectPage.js';
import AddPost from './views/Project/AddPost.js';
import DashboardPage from './views/Admin/DashboardPage.js';
import ApproveMemberPage from './views/Membership/ApproveMemberPage';
import HerbalAdrPage from './views/HerbalAdr/HerbalAdrPage.js';
import HerbalAdrAddPage from './views/HerbalAdr/HerbalAdrAddPage.js';
import SettingPage from './views/Setting/SettingPage.js';
import GuidelinePage from './views/Guideline/GuidelinePage.js';
// import Footer from './views/Footer/Footer';

//null   Anyone Can go inside
//true   only logged in user can go inside
//false  logged in user can't go inside

const AuthHeader = Auth(Header, true);
const AuthLoginPage = Auth(LoginPage, false);
const AuthProfilePage = Auth(ProfilePage, true);
const AuthManageMemberPage = Auth(ManageMemberPage, true, true);
const AuthRegisterPage = Auth(RegisterPage, true, false);
const AuthSignupPage = Auth(SignupPage, null, false);
const AuthChangePWPage = Auth(ChangePWPage, true);
const AuthOrganizationPage = Auth(OrganizationPage, true);
const AuthProjectPage = Auth(ProjectPage, true);
const AuthAddPost = Auth(AddPost, true);
const AuthDashboard = Auth(DashboardPage, true, true);
const AuthApproveMemberPage = Auth(ApproveMemberPage, true, true);
const AuthHerbalAdrPage = Auth(HerbalAdrPage, true);
const AuthHerbalAdrAddPage = Auth(HerbalAdrAddPage, true);
const AuthSettingPage = Auth(SettingPage, true, true);
const AuthGuidelinePage = Auth(GuidelinePage, true, false);

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        // TransitionComponent={Slide}
      >
        <Routes>
          <Route element={<AuthHeader />}>
            <Route path="/" element={<AuthHeader />} />
            <Route path="/register" element={<AuthRegisterPage />} />
            <Route path="/profile" element={<AuthProfilePage />} />
            <Route path="/changepw" element={<AuthChangePWPage />} />
            <Route path="/manageuser" element={<AuthManageMemberPage />} />
            <Route path="/memberapprove" element={<AuthApproveMemberPage />} />
            <Route path="/organization" element={<AuthOrganizationPage />} />
            <Route path="/project" element={<AuthProjectPage />} />
            <Route path="/project/addpost" element={<AuthAddPost />} />
            <Route path="/dashboard" element={<AuthDashboard />} />
            <Route path="/herbaladr" element={<AuthHerbalAdrPage />} />
            <Route path="/herbaladr/addherbalard" element={<AuthHerbalAdrAddPage />} />
            <Route path="/setting" element={<AuthSettingPage />} />
            <Route path="/guideline" element={<AuthGuidelinePage />} />
          </Route>
          <Route path="/signup" element={<AuthSignupPage />} />
          <Route path="/login" element={<AuthLoginPage />} />
        </Routes>

        {/* <Footer /> */}
      </SnackbarProvider>
    </Suspense>
  );
}

export default App;
